import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../ui/Reveal';
import { PAGO_LINK, VIRGEN_IMG } from '../../data/retiro';
const PASOS = [{
  paso: 'I',
  titulo: 'Reconocer',
  texto: 'El primer día eliges tu nudo: una preocupación, un miedo, una etapa, algo que necesita ser entregado.'
}, {
  paso: 'II',
  titulo: 'Agradecer',
  texto: 'Tierra, agua, fuego, aire y sonido te preparan. Lo que dolió también te trajo hasta aquí.'
}, {
  paso: 'III',
  titulo: 'Soltar',
  texto: 'En Cancún, frente a la Virgen Desatadora de Nudos, entregas eso que ya no te toca sostener.'
}, {
  paso: 'IV',
  titulo: 'Confiar',
  texto: 'Vuelves con las manos libres. Y con las manos libres se crea el próximo año.'
}];
export function Desatar() {
  return <section id="desatar" className="w-full px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'rgba(176,146,191,0.1)'
  }} data-id="element-74" data-mp="15ehwxuj91cp1">
      <div className="mx-auto max-w-7xl" data-id="element-75" data-mp="3fnv86zllo10">
        <div className="grid items-center gap-12 md:grid-cols-2 md:gap-16" data-id="element-76" data-mp="3gqmig0u1shg">
          <Reveal data-id="element-77" data-mp="3uss7hwgcrasr">
            <div className="relative overflow-hidden rounded-[2rem] shadow-lg" data-id="element-78" data-mp="3us8n8938cabk">
              <motion.img src={VIRGEN_IMG} alt="Capilla iluminada por velas con una cinta dorada anudada sobre lino blanco" className="aspect-[4/5] w-full object-cover" initial={{
              scale: 1.06
            }} whileInView={{
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.6,
              ease: 'easeOut'
            }} data-id="element-79" data-mp="3pvibfxygk0vy" />
              <div className="absolute inset-x-0 bottom-0 h-1/2" style={{
              background: 'linear-gradient(180deg, transparent 0%, rgba(42,36,32,0.75) 100%)'
            }} data-id="element-80" data-mp="2x6bdp16tvfbr" />
              <p className="absolute inset-x-0 bottom-0 p-8 font-heading text-xl font-light italic leading-relaxed text-white" data-id="element-81" data-mp="2ujskrwe1ge8n">
                "No se trata necesariamente de olvidar. Se trata de aprender a
                soltar."
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-82" data-mp="2pomyuxkmyzkk">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.3em]" style={{
            color: 'var(--glossygrape)'
          }} data-id="element-83" data-mp="2bvf5p1gwpw0r">
              <span className="h-px w-8" style={{
              background: 'var(--glossygrape)'
            }} data-id="element-84" data-mp="21xr17jti1a5e" />
              Y al final… desatar
            </span>
            <h2 className="mt-5 font-heading text-3xl font-light leading-tight sm:text-5xl" style={{
            color: 'var(--ink)'
          }} data-id="element-85" data-mp="1sxkseb8qwyck">
              La Virgen Desatadora de Nudos te espera en Cancún
            </h2>
            <p className="mt-6 text-base leading-relaxed sm:text-lg" style={{
            color: 'rgba(42,36,32,0.75)'
          }} data-id="element-86" data-mp="19b9brovjoks3">
              Después de Bacalar, nuestro camino tendrá un último significado.
              La última noche viajamos juntos a Cancún para visitar el santuario
              de la Virgen Desatanudos: la imagen que, desde hace siglos,
              recibe aquello que las manos humanas ya no pueden desenredar
              solas.
            </p>
            <p className="mt-4 text-base leading-relaxed" style={{
            color: 'rgba(42,36,32,0.7)'
          }} data-id="element-87" data-mp="2608l777v7slv">
              Es el momento más silencioso y más poderoso del viaje. Cada
              persona llega con su hilo — y lo deja ahí.
            </p>

            <ol className="mt-10 space-y-5" data-id="element-88" data-mp="2axqqmnmobpp4">
              {PASOS.map(p => <li key={p.titulo} className="flex items-start gap-5" data-id="element-89" data-mp="2v1pjtelk5uc0">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-base font-light" style={{
                backgroundColor: 'rgba(176,146,191,0.25)',
                color: 'var(--glossygrape)'
              }} aria-hidden data-id="element-90" data-mp="2z2hvsfltedbz">
                    {p.paso}
                  </span>
                  <div data-id="element-91" data-mp="2g4ysztpy9qy0">
                    <h3 className="font-heading text-lg font-normal" style={{
                  color: 'var(--ink)'
                }} data-id="element-92" data-mp="2l3rx4vjck5li">
                      {p.titulo}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed" style={{
                  color: 'rgba(42,36,32,0.7)'
                }} data-id="element-93" data-mp="dazk8a5agjy">
                      {p.texto}
                    </p>
                  </div>
                </li>)}
            </ol>

            <a href={PAGO_LINK} target="_blank" rel="noreferrer" className="mt-10 inline-flex rounded-full px-10 py-4 text-sm font-medium text-white transition-transform hover:scale-[1.04]" style={{
            backgroundColor: 'var(--darkgoldenrod)'
          }} data-id="element-94" data-mp="1g4d6kx2xe74s">
              Quiero separar mi cupo
            </a>
          </Reveal>
        </div>
      </div>
    </section>;
}